import React, { PropsWithChildren } from 'react';

import { Box, Grid } from '@mui/material';
import clsx from 'clsx';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getIsOpenFullScreenTable } from 'store/useBusinessToolStore/selectors';

import styles from './FieldTableContainer.module.scss';

export const FieldTableContainer: React.FC<PropsWithChildren & { overflow?: boolean }> = ({
  children,
  overflow = true,
}) => {
  const isOpenFullScreenTable = useBusinessToolStore(getIsOpenFullScreenTable);
  return (
    <Box className={overflow ? styles.overflowBox : ''}>
      <Grid container className={clsx([styles.container, isOpenFullScreenTable && styles.scrollableContainer])}>
        {children}
      </Grid>
    </Box>
  );
};
